import React from 'react';

import styles from './HomeRequisitionsSection.module.scss';

export default function HomeRequisitionsSection() {
  return (
    <div className={styles.requisitionSection}>
      <div className="container">
        <div className="lending-title">Post and Fill Job Requisitions:</div>
        <div className={styles.cardRow}>
          <div className={styles.cardItem}>
            <div className={styles.cardHead}>
              <div className={styles.cardIconWrapper}>
                <span className="icon icon-target"></span>
              </div>
            </div>
            <div className={styles.cardText}>
              <p>Create and post job reqs in minutes</p>
            </div>
          </div>

          <div className={styles.cardItem}>
            <div className={styles.cardHead}>
              <div className={styles.cardIconWrapper}>
                <span className="icon icon-research"></span>
              </div>
            </div>
            <div className={styles.cardText}>
              <p>Target specialty recruiters to assign job reqs</p>
            </div>
          </div>

          <div className={styles.cardItem}>
            <div className={styles.cardHead}>
              <div className={styles.cardIconWrapper}>
                <span className="icon icon-candidates"></span>
              </div>
            </div>
            <div className={styles.cardText}>
              <p>Review and select qualified candidates</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
